import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    InputLabel,
    MenuItem,
    Select
} from "@mui/material";
import React from "react";
import CourseData from "../backend/dataservices/CourseData";
import AttendanceData from "../backend/dataservices/AttendanceData";

export default function TableDateChooser(props) {

    const [dateValue, setDateValue] = React.useState('');
    const [dates, setDates] = React.useState([]);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        (async () => {
            // eslint-disable-next-line
            await loadDates();
        })();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    async function loadDates() {
        CourseData.fetchDatesByCourseID(props.course.KS_ID).then(value => {
            // Hat der Kurs keine Termine, antwortet der Server mit 204 und
            // axios liefert daraus einen leeren String statt eines Arrays.
            setDates(Array.isArray(value) ? value : []);
            setLoading(false);
        }, () => {
            setDates([]);
            setLoading(false);
        });
    }

    // Ohne den Veranstaltungsort sind gleich datierte Termine (Dubletten aus der
    // Migration) im Dropdown nicht voneinander zu unterscheiden.
    function formatDate(day, time) {
        const date = new Date(day).toLocaleDateString('DE-de');
        return time == null ? date : date + ", " + new Date(time).toLocaleTimeString('DE-de', {hour: '2-digit', minute: '2-digit'});
    }

    function dateLabel(date) {
        const range = formatDate(date.KD_Anfangstag, date.KD_Beginn) + " - " + formatDate(date.KD_Letzter_Tag, date.KD_Ende);
        return date.KD_Veranstaltungsort ? range + " (" + date.KD_Veranstaltungsort + ")" : range;
    }

    function save() {
        AttendanceData.migratePlannedAttendance(props.employeeID, dateValue, props.attendanceID, props.newValue, props.type).then(value => {
            props.onClose();
        }, (error) => {
            props.abortChanges();
        });
    }

    return (
        <div>
            <Dialog open={props.openDialog} onClose={props.abortChanges} fullWidth>
                <DialogTitle sx={{backgroundColor: 'rgb(0,150,136)'}} color={"white"}>
                    Kurstermin wählen
                </DialogTitle>

                <DialogContentText margin={'3% 3% 3% 3%'}>
                    {props.employeeName} auf Kurs {props.course.KS_Kursname} anmelden <br/>
                    Neuer Status <b>{props.newValue}</b>
                </DialogContentText>

                <DialogContent>
                    <FormControl fullWidth>
                        <InputLabel>Termin</InputLabel>
                        <Select
                            value={dateValue}
                            label={"Termin"}
                            disabled={dates.length === 0}
                            onChange={(event) => setDateValue(event.target.value)}>

                            {dates.map(function (select) {
                                return <MenuItem
                                    key={select.KD_ID}
                                    value={select.KD_ID}>{dateLabel(select)}</MenuItem>
                            })}
                        </Select>
                    </FormControl>

                    {!loading && dates.length === 0 ?
                        <DialogContentText marginTop={'3%'} color={'error'}>
                            Für diesen Kurs ist kein Kurstermin hinterlegt. Der Status kann daher nicht
                            geändert werden. Bitte zunächst in der Kursverwaltung einen Termin anlegen –
                            oder prüfen, ob die Anmeldung auf einem doppelt angelegten Kurs gleichen
                            Namens liegt.
                        </DialogContentText>
                        : null
                    }
                </DialogContent>
                <DialogActions>
                    <Button style={{color: "gray"}} onClick={props.abortChanges}>Abbrechen</Button>
                    <Button disabled={dateValue === ''} color={"primary"} onClick={save}>Speichern</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}